module.exports = __webpack_public_path__ + "static/media/cashback_wallet_modal_asset_03.c9d801e7.svg";